export const COLOR_FOREGROUND_KEY = "qrtoolkit-color-foreground";
export const COLOR_BACKGROUND_KEY = "qrtoolkit-color-background";
export const THEME_KEY = "qrtoolkit-theme";
